import React from 'react';
import { motion } from 'framer-motion';
import { XIcon, CheckIcon } from 'lucide-react';
export function Differentiation() {
  const notItems = ['Motivación vacía', 'Consejos genéricos', 'Teoría larga'];
  const yesItems = ['Simple', 'Directo', 'Accionable desde el día 1'];
  return <section className="w-full bg-gray-50 py-20 md:py-32 px-4" data-id="element-29">
      <div className="max-w-6xl mx-auto" data-id="element-30">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} data-id="element-31">
          <h2 className="text-4xl md:text-6xl font-black text-center mb-16" data-id="element-32">
            Esto no es lo típico
          </h2>

          <div className="grid md:grid-cols-2 gap-8" data-id="element-33">
            <div className="bg-white p-8 rounded-xl shadow-lg" data-id="element-34">
              <h3 className="text-3xl font-bold mb-8 text-red-600" data-id="element-35">NO es:</h3>
              <div className="space-y-4" data-id="element-36">
                {notItems.map((item, index) => <div key={index} className="flex items-start gap-4" data-id="element-37">
                    <XIcon className="w-6 h-6 text-red-500 flex-shrink-0 mt-1" data-id="element-38" />
                    <p className="text-xl" data-id="element-39">{item}</p>
                  </div>)}
              </div>
            </div>

            <div className="bg-white p-8 rounded-xl shadow-lg" data-id="element-40">
              <h3 className="text-3xl font-bold mb-8 text-green-600" data-id="element-41">SÍ es:</h3>
              <div className="space-y-4" data-id="element-42">
                {yesItems.map((item, index) => <div key={index} className="flex items-start gap-4" data-id="element-43">
                    <CheckIcon className="w-6 h-6 text-green-500 flex-shrink-0 mt-1" data-id="element-44" />
                    <p className="text-xl font-semibold" data-id="element-45">{item}</p>
                  </div>)}
              </div>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}